export default __webpack_public_path__ + "dist/media/OpenArrowWhite.06f8821b.svg";